import { useEffect, useState } from 'react'
import { apiGet } from '../../api'

interface Point { ts: number; status: string; latency_ms: number | null }
interface HistoryResponse { apps: Record<string, Point[]>; hours: number }

interface Props {
  appId: string
  hours?: number
}

const STATUS_COLOR: Record<string, string> = {
  up:       '#3ddc84',
  degraded: '#ffb454',
  down:     '#ff6b81',
}
const BUCKETS = 48     // 24h / 30min — visual density

export default function HealthStrip({ appId, hours = 24 }: Props) {
  const [data, setData] = useState<Point[]>([])

  useEffect(() => {
    let alive = true
    apiGet<HistoryResponse>(`/infra/health/history?hours=${hours}`)
      .then(r => { if (alive) setData(r.apps[appId] ?? []) })
      .catch(() => undefined)
    return () => { alive = false }
  }, [appId, hours])

  // Bucket into BUCKETS slots, picking the worst status per slot.
  const now = Date.now()
  const start = now - hours * 3600_000
  const slotMs = (hours * 3600_000) / BUCKETS
  const slots: { status: string | null; count: number }[] = Array.from({ length: BUCKETS },
    () => ({ status: null, count: 0 }))
  for (const p of data) {
    const idx = Math.min(BUCKETS - 1, Math.max(0, Math.floor((p.ts - start) / slotMs)))
    const slot = slots[idx]!
    slot.count += 1
    if (slot.status === null) slot.status = p.status
    else if (slot.status === 'up' && p.status !== 'up') slot.status = p.status
    else if (slot.status === 'degraded' && p.status === 'down') slot.status = 'down'
  }

  return (
    <div className="health-strip" title={`${data.length} checks · last ${hours}h`}>
      {slots.map((s, i) => (
        <span key={i} className="health-cell"
          style={{
            background: s.status ? STATUS_COLOR[s.status] : '#2a3148',
            opacity:    s.status ? 1 : 0.35,
          }} />
      ))}
    </div>
  )
}
